/* ag-v81b.js - AquaGrip CT (v81b, 27 Oct 2026, Claude). */
/* ---------- 4. v81b: video bands ----------
   Home "Premium Marine Foam" band (rich_text_6bcHeN + multicolumn_VGJiK7 +
   rich_text_tcKzby) gets ONE continuous ocean video behind all three sections;
   "Customer builds" on studio pages gets the same ocean loop (v82b: Chris
   did not like the abstract wave there). The poster image
   shows when motion is reduced / Save-Data is on. */
(function(){
  'use strict';
  if(window.__agv81b) return; window.__agv81b = true;
  var C = window.AGN || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''));
  function band(first, rest, src, cls){
    if(!first || first.querySelector('.agv-bandvid')) return;
    var wrap = document.createElement('div');
    wrap.className = 'agv-bandvid ' + (cls || ''); wrap.setAttribute('aria-hidden', 'true');
    first.insertBefore(wrap, first.firstChild);
    first.classList.add('agv-band-top');
    rest.forEach(function(s){ s.classList.add('agv-band-rest'); });
    var last = rest.length ? rest[rest.length - 1] : first;
    function size(){ wrap.style.height = Math.ceil(last.getBoundingClientRect().bottom - first.getBoundingClientRect().top) + 'px'; }
    size(); window.addEventListener('resize', size); window.addEventListener('load', size);
    if('ResizeObserver' in window){ var ro = new ResizeObserver(size); [first].concat(rest).forEach(function(s){ ro.observe(s); }); }
    if(!src || reduce || saveData) return;
    var v = document.createElement('video');
    v.muted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('preload', 'none');
    wrap.appendChild(v);
    var loaded = false;
    v.addEventListener('playing', function(){ wrap.classList.add('is-on'); });
    function play(){ if(!loaded){ v.src = src; loaded = true; } var p = v.play(); if(p && p.catch) p.catch(function(){}); }
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting) play(); else if(loaded) v.pause(); }); }, {rootMargin:'200px 0px'}).observe(wrap);
    } else play();
  }
  function init(){
    var a = document.querySelector('[id$="__rich_text_6bcHeN"]');
    if(a){
      var rest = [], n = a.nextElementSibling;
      while(n && /__(multicolumn_VGJiK7|rich_text_tcKzby)$/.test(n.id || '')){ rest.push(n); n = n.nextElementSibling; }
      band(a, rest, C.homeVideo, 'is-ocean');
    }
    /* v88: no video behind "Customer builds" any more - it is a photo wall on navy (ag-v88.css). */
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ---------- 5. v82b: "Customer builds" coverflow ----------
   Full-width row: the photo in the middle is big, the ones either side are
   smaller and dimmed, and there are always photos on both sides (the row
   wraps around). Arrows wrap too. Builds on the carousel made by ag-v81.js. */
(function(){
  'use strict';
  if(window.__agv82b) return; window.__agv82b = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function cover(car){
    if(car.__cf) return; car.__cf = true;
    var track = car.querySelector('.agv-track'), bar = car.querySelector('.agv-bar');
    if(!track || !bar) return;
    var first = track.firstElementChild, n = track.children.length;
    if(n < 3) return;
    car.classList.add('agv-cf');
    for(var i = 0; i < Math.floor(n / 2); i++) track.insertBefore(track.lastElementChild, track.firstElementChild);
    function list(){ return Array.prototype.slice.call(track.children); }
    function centre(el, smooth){ track.scrollTo({left: el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2, behavior: (smooth && !reduce) ? 'smooth' : 'auto'}); }
    function nearest(){
      var mid = track.scrollLeft + track.clientWidth / 2, best = null, bd = Infinity;
      list().forEach(function(s){ var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - mid); if(d < bd){ bd = d; best = s; } });
      return best;
    }
    function mark(){ var a = nearest(); list().forEach(function(s){ s.classList.toggle('is-active', s === a); }); }
    /* keep at least two photos on each side of the one in the middle */
    function balance(){
      var a = nearest(), l = list(), i = l.indexOf(a), moved = false;
      while(i < 2){ track.insertBefore(track.lastElementChild, track.firstElementChild); i++; moved = true; }
      while(i > l.length - 3){ track.appendChild(track.firstElementChild); i--; moved = true; }
      if(moved){ var snap = track.style.scrollSnapType; track.style.scrollSnapType = 'none'; centre(a, false); track.style.scrollSnapType = snap; }
    }
    var p0 = bar.children[0], n0 = bar.children[2];
    var prev = p0.cloneNode(true), next = n0.cloneNode(true);
    p0.parentNode.replaceChild(prev, p0); n0.parentNode.replaceChild(next, n0);
    prev.disabled = false; next.disabled = false;
    function step(d){ balance(); var l = list(), i = l.indexOf(nearest()) + d; if(l[i]) centre(l[i], true); }
    /* tapping a side photo brings it to the middle; only the middle one opens full screen */
    track.addEventListener('click', function(e){
      var f = e.target.closest && e.target.closest('.agv-track > *');
      if(f && !f.classList.contains('is-active')){ e.preventDefault(); e.stopPropagation(); balance(); centre(f, true); }
    }, true);
    prev.addEventListener('click', function(){ step(-1); });
    next.addEventListener('click', function(){ step(1); });
    var raf = 0, idle = 0;
    track.addEventListener('scroll', function(){
      if(!raf) raf = requestAnimationFrame(function(){ raf = 0; mark(); });
      clearTimeout(idle); idle = setTimeout(balance, 160);
    }, {passive:true});
    function home(){ centre(first, false); mark(); }
    home();
    window.addEventListener('load', home);
    window.addEventListener('resize', function(){ var a = nearest(); if(a) centre(a, false); });
  }
  var tries = 0;
  (function wait(){
    var cars = document.querySelectorAll('.ag-work .agv-car');
    if(cars.length){ Array.prototype.forEach.call(cars, cover); return; }
    if(++tries < 60) setTimeout(wait, 100);
  })();
})();
